// Health check + re-materialization for cart image Files.
//
// iOS Safari can evict the backing data of a File that was restored from
// IndexedDB or held in memory while the tab was backgrounded. The object
// still reports its original size, but reading it fails or comes up short —
// and when fetch() streams it as a request body, the upload truncates
// mid-send, which the backend's multipart parser reports as
// "Unexpected end of form".
//
// Reading the bytes up front does two things: it detects a dead blob before
// we waste an upload, and the returned copy is backed by in-memory bytes, so
// it cannot be evicted between the check and the send.
export async function rematerializeFile(file) {
  if (!file) return null;
  try {
    const buffer = await file.arrayBuffer();
    if (buffer.byteLength === 0) return null;
    if (file.size > 0 && buffer.byteLength !== file.size) return null;
    return new File([buffer], file.name, {
      type: file.type,
      lastModified: file.lastModified
    });
  } catch (error) {
    console.warn('⚠️ File data is no longer readable:', file.name, error);
    return null;
  }
}

export const EXPIRED_FILE_MESSAGE = (fileName) =>
  `The saved image "${fileName}" is no longer readable on this device — ` +
  'browsers clear saved images after a while. Please remove it from the ' +
  'cart and upload it again.';
